define('behavior/drag.and.drop.files.behavior',['require','exports','module','underscore','marionette','fine-uploader/dnd','backbone.radio','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                      = require('underscore'),
      Mn                     = require('marionette'),
      qq                     = require('fine-uploader/dnd'),
      Radio                  = require('backbone.radio'),
      ResolveOptionsBehavior = require('fukit').ResolveOptionsBehavior;

  var DragAndDropFilesBehavior = Mn.Behavior.extend({
    onFirstRender: function() {
      this.initializeFineUploaderDragAndDrop();
    },

    initializeFineUploaderDragAndDrop: function() {
      var self = this;
      var dragAndDropOptions = Mn._getValue(this.getOption('dragAndDropOptions'), this) | {};

      dragAndDropOptions = ResolveOptionsBehavior.resolveViewValue(dragAndDropOptions, this.view);

      var callbacks = dragAndDropOptions.callbacks || {};

      this.dragAndDrop = new qq.DragAndDrop(
        _.extend({}, dragAndDropOptions, {
          dropZoneElements: self.determineDropZoneElements(),

          classes: {
            dropActive: 'fine uploader drop active',
          },

          callbacks: {
            processingDroppedFiles: function() {},
            processingDroppedFilesComplete: function(files, dropTarget) {
              self.getFineUploaderInstance().addFiles(files);
            },
          },
        })
      );
    },

    determineDropZoneElements: function() {
      var previewMode = Radio.request('AppKit.controllerService', 'state').get('previewMode') || false;
      var disabled = this.view.getOption('disabled');

      if (previewMode || disabled) {
        return [];
      } else {
        return [this.view.el];
      }
    },

    getFineUploaderInstance: function() {
      return this.view.$('.fine-uploader-instance').data('fineUploaderInstance');
    },
  });

  module.exports = DragAndDropFilesBehavior;
});

